/* eslint-disable react/require-default-props */
import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';

import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';

import {
  Container,
  HeaderCloseButton,
  HeaderContainer,
  HeaderTitle,
} from './styles';

interface ISidesheetProps {
  open: boolean;
  modalState: (opened: boolean) => void;
  children?: React.ReactNode;
  title: string | JSX.Element;
  sidesheetSize: any;
}

function Sidesheet({
  open,
  modalState,
  children,
  title,
  sidesheetSize,
}: ISidesheetProps) {
  const useStyles = makeStyles({
    list: {
      width: `${sidesheetSize}`,
      height: 'calc(100% - 80px)',
      bottom: '0',
      marginTop: '80px',
    },
    color: {
      backgroundColor: 'rgba(0,0,0,0.5)',
    },
  });

  const classes = useStyles();

  return (
    <Drawer
      anchor="right"
      open={open}
      classes={{ paper: classes.list, modal: classes.color }}
      onClose={() => modalState(false)}
    >
      <HeaderContainer>
        <HeaderTitle>{title}</HeaderTitle>
        <HeaderCloseButton type="button" onClick={() => modalState(false)}>
          <AiOutlineClose size={24} color="#B2B2B2" />
        </HeaderCloseButton>
      </HeaderContainer>
      {children}
    </Drawer>
  );
}

export default Sidesheet;
